import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isReactElement = function (value) {
    return !!value && React.isValidElement(value);
};
/**
 * Extracts all string children from a react element to manually configure
 * assistive technology notifications.
 */
export var buildRecursiveString = function (element) {
    var _a, _b, _c, _d;
    if ((_a = element === null || element === void 0 ? void 0 : element.props) === null || _a === void 0 ? void 0 : _a.children) {
        var children = element.props.children;
        if (typeof children === 'string') {
            return children;
        }
        if (isReactElement(children)) {
            return buildRecursiveString(children);
        }
        if (Array.isArray(children)) {
            var output = '';
            for (var i = 0; i < children.length; i += 1) {
                if (typeof children[i] === 'string') {
                    output += children[i];
                }
                if (isReactElement(children[i])) {
                    output += buildRecursiveString(children[i]);
                }
            }
            return output;
        }
        // handles use cases where we pass text to a component as a
        // `text` prop instead of as a `string` child.
    }
    else if (((_b = element === null || element === void 0 ? void 0 : element.props) === null || _b === void 0 ? void 0 : _b.text) && typeof element.props.text === 'string') {
        return element.props.text;
        // handles use cases where we pass a react element to component as a
        // `content` props instead of as a child component.
    }
    else if (((_c = element === null || element === void 0 ? void 0 : element.props) === null || _c === void 0 ? void 0 : _c.content) && isReactElement(element.props.content)) {
        return buildRecursiveString(element.props.content);
    }
    else if (((_d = element === null || element === void 0 ? void 0 : element.props) === null || _d === void 0 ? void 0 : _d.content) &&
        typeof element.props.text === 'string') {
        return element.props.text;
    }
    return '';
};
/**
 * Takes a child element of type T and returns the first parent
 * of that element of type K.
 */
export var findParentElement = function (childElement, tagName) {
    if (!childElement)
        return null;
    var parentEl = null;
    var currentEl = childElement.parentElement;
    while (!parentEl) {
        if (!currentEl)
            break;
        if (currentEl.tagName === tagName) {
            parentEl = currentEl;
        }
        else {
            currentEl = currentEl.parentElement;
        }
    }
    return (parentEl === null || parentEl === void 0 ? void 0 : parentEl.tagName) === tagName ? parentEl : null;
};
//# sourceMappingURL=componentTraversal.js.map